const $ = jQuery.noConflict();
window.initChecker = true;
const menuItemsSlider = {
    menuWrapper: $('.slider-block .slides'),

    initSlider() {
        if (!window.matchMedia('(max-width: 992px)').matches) {
            window.initChecker = true;
        }
        if (window.matchMedia('(max-width: 992px)').matches && window.initChecker) {
            window.initChecker = false;
            $(this).slick({
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                pauseOnHover: false,
                autoplay: false,
                responsive: [{
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }
    },
    init() {
        if (this.menuWrapper) {
            this.menuWrapper.each(this.initSlider);
        }
    }
}

export default menuItemsSlider;
